import QuoteRateSection, { QuoteRateSectionProps } from './QuoteRateSection';

export type { QuoteRateSectionProps };
export default QuoteRateSection;
